import React, { Component, useDebugValue } from 'react';
import { Link } from 'react-router';
import { Row } from 'reactstrap';
import { FieldCol, FieldGroup, FieldLabel, FieldSelect } from '../../../../applications/contracts/Elements';
export default class EditSecurityCurrencyCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            securityCurrencycard: {},
            error: {}
        }
    }
    componentDidMount() {
        this.updateHdState(this.props.securityCurrencycard);
    }
    updateHdState = (securityCurrencycard) => {
        let data = Object.assign({}, securityCurrencycard);
        this.setState({
            securityCurrencycard: data
        });
    }
    updateForm = (type, value) => {
        if (['contractual_currency', 'base_currency'].includes(type)) {
            this.setState(prevState => ({
                securityCurrencycard: {
                    ...prevState.securityCurrencycard,
                    titan_extra_fields: {
                        ...prevState.securityCurrencycard?.titan_extra_fields,
                        [type]: value,
                    },
                },
            }));
        }
    }
    updateSecurityCurrencycard = (e) => {
        e.preventDefault();
        const titan_extra_fields = { ...this.state.securityCurrencycard.titan_extra_fields };
        this.props.updateSecurityCurrencycard({ titan_extra_fields });
    }
    render() {
        const { type } = this.props;
        const { securityCurrencycard } = this.state;
        return (
            <form onSubmit={(e) => this.updateSecurityCurrencycard(e)}>
                <div style={{ height: (window.innerHeight - 170) + 'px', overflow: 'auto', marginBottom: '60px' }}>
                    <Row>
                        <FieldCol md="12">
                            <FieldGroup className="form-group">
                                <FieldLabel className="label">Base Amount Currency</FieldLabel>
                                <FieldSelect
                                    placeholder='Select Base Currency'
                                    keyParam="base_currency"
                                    value={securityCurrencycard?.titan_extra_fields?.base_currency || ''}
                                    type={type}
                                    options={[{ label: 'USD', value: 'USD' }, { label: 'EUR', value: 'EUR' }]}
                                    updateField={this.updateForm}
                                    labelKey='label'
                                    valueKey='value'
                                />
                            </FieldGroup>
                        </FieldCol>
                    </Row>
                    <Row>
                        <FieldCol md="12">
                            <FieldGroup className="form-group">
                                <FieldLabel className="label">Contractual Amount Currency</FieldLabel>
                                <FieldSelect
                                    placeholder='Select Contractual Currency'
                                    keyParam="contractual_currency"
                                    value={securityCurrencycard?.titan_extra_fields?.contractual_currency || ''}
                                    type={type}
                                    options={[{ label: 'USD', value: 'USD' }, { label: 'EUR', value: 'EUR' }]}
                                    updateField={this.updateForm}
                                    labelKey='label'
                                    valueKey='value'
                                />
                            </FieldGroup>
                        </FieldCol>
                    </Row>
                </div>
                <div className="submit-block">
                    <input type="submit" className="primary-btn" value="Save Changes" />
                    <Link onClick={() => this.props.toggleEditSideBar()} >Cancel</Link>
                </div>
            </form>
        )
    }
}
